<template>
  <div class="footer">
    <div class="footerbg"> <img src="../../static/img/footebg.png" alt=""></div>
    <div class="footeres">
      <div class="footer-box min">
        <div class="footer-left">
          <div class="contact-my">
            <div class="contact-left"><img src="../../static/img/footerrg.png" alt=""></div>
            <div class="contact-right">
               <p class="contact-m-text">联系我们</p>
            <p class="contact-sub-text">Contact us</p></div>

          </div>
          <div class="contact-content">
            <p class>{{phoneList.Intr}}</p>
            <p class>地址：{{addressList.Intr}}</p>
            <!-- <p class>邮箱：{{emaillist.Intr}}</p> -->
          </div>
        </div>
        <div class="footer-Code">
          <div class="footer-Code-buy">
            <p style="background:#0078FF;color:#fff;">关注</p>
            <div class="code-icon">
              <img :src="baseURL+attenList.Pic" alt />
            </div>
            <div class="to-buy">-欢迎您关注-</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <img src="../../static/img/cation.png" alt="">
        <span>Copyright © 2020-2021 szkjg.com All Rights Reserved</span>
        <span>版权所有：朔州市科学技术馆 晋ICP备2021010377号-1</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addressList:{},
      phoneList:{},
      payList:{},
      baseURL:window.SITE_CONFIG.baseUrl+'/yxht',
      emaillist:{},
      attenList:{}
    };
  },
  created() {
    this.footerFun();
  },
  methods: {
    footerFun() {
        // 地址
      this.$http
        .get("yxapi/api/News/GetNewsModelByCategoryId", {
          CategoryId: "2149c3c4-21d4-4449-8f5c-bd5344714c00"
        })
        .then(res => {
          this.addressList = JSON.parse(res.data.Result);
          console.log(9999,this.addressList)
        });
        // 电话
          this.$http
        .get("yxapi/api/News/GetNewsModelByCategoryId", {
          CategoryId: "44ca79b6-7425-4355-b57a-fbf9650108f8"
        })
        .then(res => {
          this.phoneList = JSON.parse(res.data.Result);
        });
        //   邮箱
          this.$http
        .get("yxapi/api/News/GetNewsModelByCategoryId", {
          CategoryId: "ae9de709-e9ab-46bc-b822-0f60e2191e88"
        })
        .then(res => {
          this.emaillist = JSON.parse(res.data.Result);
        });
        // 欢饮购买
          this.$http
        .get("yxapi/api/News/GetNewsModelByCategoryId", {
          CategoryId: "b385e387-a922-494e-b84f-ef23662acfa3"
        })
        .then(res => {
          this.payList = JSON.parse(res.data.Result);
        });
        // 关注
          this.$http
        .get("yxapi/api/News/GetNewsModelByCategoryId", {
          CategoryId: "37f889ba-70e0-437e-a4db-06c856119d9b"
        })
        .then(res => {
          this.attenList = JSON.parse(res.data.Result);
        });
    }
  }
};
</script>
<style lang="postcss" scoped>
.footer {
  background: #041121;
width: 100%;
    height: 310px;
}
.footerbg{
  width:1200px;
  height:280px;
  /* position: absolute; */
  margin: 0 auto;
}
.footerbg img{
  width:1200px;
  height:280px;

}
.footeres{
  position: relative;
    top: -277px;

}
.footer-box {
  height: 300px;
  display: flex;
  justify-content: space-between;
}
.contact-my {
  /* border-left: 3px solid #0078ff; */
  /* padding-left: 16px; */
  margin-top: 58px;
  display: flex;
  height: 46px;
  align-items: center;
}
.contact-left img{
  width:3px;
  height: 46px;

}
.contact-right{
  margin-left: 17px;
}
.contact-m-text {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f2f2f8;
}
.contact-sub-text {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.contact-content p:nth-child(1) {
  font-size: 24px;
  color: #0078ff;
  margin-top: 41px;
  margin-bottom: 10px;
  font-weight: bold;
}
.contact-content p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #999999;
  line-height: 30px;
}
.contact-content p:nth-child(3) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #999999;
  line-height: 30px;
}
.footer-Code {
  display: flex;
  margin-top: 89px;
}

.footer-Code .footer-Code-buy p {
  width: 106px;
  height: 31px;
  text-align: center;
  line-height: 31px;
  margin-bottom: -3px;
  border-radius: 5px 5px 0px 0;
  /* background: #0078FF;
        */
}
.footer-Code .footer-Code-buy:nth-child(1) {
  margin-right: 27px;
}
.to-buy {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  line-height: 40px;
  color: #666666;
}

.code-icon {
  width: 106px;
  height: 106px;
  background: #ffffff;
  /* border-radius: 5px; */
}
.code-icon img {
  width: 100%;
  height: 100%;
   border-radius: 5px;
}
.footer-bottom {
  width: 100%;
  margin: 0 auto;
 display: flex;
 align-items: center;
 justify-content: center;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  height: 60px;
  line-height: 60px;
  text-align: center;
    background: #041121;
    border-top: 1px solid rgba(0,125,250, 0.3);
  /* border-top: 1px solid #0078ff; */
}
.footer-bottom img{
width: 24px;
height: 30px;
margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue